import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const Puzzle: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_12280_28750)'>
        <path
          d='M19.0688 1.09766H4.0484C2.67417 1.09766 1.55859 2.27151 1.55859 3.71195V19.4825C1.55859 20.9238 2.67421 22.0977 4.0484 22.0977H19.068C20.4399 22.0977 21.5578 20.9238 21.5578 19.4834L21.5586 11.6002V3.71216C21.5586 2.27168 20.4407 1.09766 19.0688 1.09766ZM11.8844 4.55027V1.77764H19.0688C20.0844 1.77764 20.911 2.64471 20.911 3.71193V11.2595H18.5766C18.4188 10.1447 17.5008 9.28587 16.397 9.28587C15.2931 9.28587 14.379 10.1447 14.2212 11.2595H11.8844V8.48774C11.8844 8.30071 11.7383 8.14731 11.5602 8.14731C10.7023 8.14731 10.0039 7.41641 10.0039 6.51736C10.0039 5.6183 10.7016 4.8874 11.5602 4.8874C11.7406 4.88986 11.8844 4.73648 11.8844 4.55027ZM2.20619 3.7119C2.20619 2.6455 3.03198 1.77762 4.04838 1.77762H11.2366V4.23273C10.1749 4.39679 9.3569 5.36066 9.3569 6.51731C9.3569 7.67641 10.1749 8.63622 11.2366 8.80191V11.257H8.59678C8.41866 11.257 8.27256 11.4104 8.27256 11.5974C8.27256 12.4965 7.57646 13.2274 6.72022 13.2274C5.86398 13.2274 5.16788 12.4965 5.16788 11.5974C5.16788 11.4088 5.02178 11.257 4.84366 11.257H2.20605L2.20619 3.7119ZM11.2366 18.649V21.4151H4.0484C3.03278 21.4151 2.20621 20.548 2.20621 19.4808V11.9397H4.54442C4.70223 13.0529 5.61864 13.9093 6.72022 13.9093C7.82412 13.9093 8.73822 13.0529 8.89602 11.9397H11.2342V14.7058C11.2342 14.8945 11.3803 15.0463 11.5584 15.0463C12.4147 15.0463 13.1108 15.7772 13.1108 16.6762C13.1108 17.5769 12.4147 18.3103 11.5584 18.3103C11.3827 18.3095 11.2366 18.4628 11.2366 18.649ZM20.9108 19.4833C20.9108 20.5497 20.085 21.4175 19.0686 21.4175H11.8842V18.9664C12.9444 18.8007 13.76 17.8369 13.76 16.6778C13.76 15.5204 12.9444 14.559 11.8842 14.3933V11.9396H14.5186C14.6983 11.9396 14.8428 11.7887 14.8428 11.5992C14.8428 10.6985 15.5389 9.96514 16.3952 9.96514C17.253 9.96514 17.9514 10.6977 17.9514 11.5992C17.9514 11.7879 18.0952 11.9396 18.2756 11.9396H20.9101L20.9085 19.4832L20.9108 19.4833Z'
          fill='url(#paint0_linear_12280_28750)'
          stroke='url(#paint1_linear_12280_28750)'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_12280_28750'
          x1='5.70013'
          y1='2.52962'
          x2='15.5473'
          y2='21.3263'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_28750'
          x1='5.70013'
          y1='2.52962'
          x2='15.5473'
          y2='21.3263'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <clipPath id='clip0_12280_28750'>
          <rect
            width='24'
            height='24'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Puzzle;
